import classNames from "classnames/bind";
import { Link } from "react-router-dom";
import { Previous } from "../../../components/Icons/Icons";
import styles from "./HeaderRegister.module.css";
import PropTypes from "prop-types";

const cx = classNames.bind(styles)

function HeaderRegister({ backTo, header }) {
    return (
        <div className={cx('register-header')}>
            <div className={cx('button-back')}>
                <Link to={backTo} className={cx('back-icon')}>
                    <Previous />
                </Link>
            </div>
            <div className={cx('title')}>
                {header ? header : 'Đăng ký tài khoản'}
            </div>
        </div>
    )
}
HeaderRegister.propTypes = {
    backTo: PropTypes.string,
    header: PropTypes.string
};
export default HeaderRegister;